
import { supabase } from "@/integrations/supabase/client";
import { Screen } from "@/models/screen";

// Guarda una nueva pantalla
export async function addScreenToSupabase(screenData: Omit<Screen, "id">) {
  const { name, location, totalSpaces, occupiedSpaces, availableSpaces, occupancyRate } = screenData;
  console.log("Adding screen to Supabase:", screenData);
  
  try {
    const { data, error } = await supabase
      .from("screens")
      .insert([
        {
          name,
          location,
          max_ads: totalSpaces,
          occupied_spaces: occupiedSpaces,
          available_spaces: availableSpaces,
          occupancy_rate: occupancyRate,
        }
      ])
      .select();
    
    if (error) {
      console.error("Error adding screen to Supabase:", error);
      throw error;
    }
    
    console.log("Screen added successfully:", data);
    return data?.[0] || null;
  } catch (err) {
    console.error("Exception when adding screen:", err);
    throw err;
  }
}

export async function updateScreenInSupabase(screen: Screen) {
  const { id, name, location, totalSpaces, occupiedSpaces, availableSpaces, occupancyRate } = screen;
  console.log("Updating screen in Supabase:", screen);
  
  try {
    const { error } = await supabase
      .from("screens")
      .update({
        name,
        location,
        max_ads: totalSpaces,
        occupied_spaces: occupiedSpaces,
        available_spaces: availableSpaces,
        occupancy_rate: occupancyRate,
      })
      .eq("id", id);
      
    if (error) {
      console.error("Error updating screen in Supabase:", error);
      throw error;
    }
    
    console.log("Screen updated successfully");
  } catch (err) {
    console.error("Exception when updating screen:", err);
    throw err;
  }
}

export async function deleteScreenFromSupabase(screenId: string) {
  console.log("Deleting screen from Supabase:", screenId);
  
  try {
    const { error } = await supabase
      .from("screens")
      .delete()
      .eq("id", screenId);
      
    if (error) {
      console.error("Error deleting screen from Supabase:", error);
      throw error;
    }
    
    console.log("Screen deleted successfully");
  } catch (err) {
    console.error("Exception when deleting screen:", err);
    throw err;
  }
}
